import { jsx as _jsx } from "react/jsx-runtime";
const TooltipContainer = ({ children }) => (_jsx("div", Object.assign({ role: "none", 
    /* To prevent zoom select from possible triggering */
    onMouseDown: (event) => event.stopPropagation() }, { children: children }), void 0));
export default TooltipContainer;
